import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const ACTIVITIES_PAGE_SIZE = 25;

export const ACTIVITIES_ANY_FILTER = 'any';

export const ACTIVITIES_AGE_FILTER_DAYS = [1, 3, 7] as const;

export type ActivitiesAgeFilterDays =
  (typeof ACTIVITIES_AGE_FILTER_DAYS)[number];

export const ACTIVITIES_AGE_FILTER_I18N: Record<
  ActivitiesAgeFilterDays,
  string
> = {
  1: 'agingOneDay',
  3: 'agingThreeDays',
  7: 'agingSevenDays',
};

export const isActivitiesAgeFilterDays = (
  days: number | null,
): days is ActivitiesAgeFilterDays =>
  ACTIVITIES_AGE_FILTER_DAYS.includes(days as ActivitiesAgeFilterDays);

/**
 * Inclusive UTC `GraphQLDate` upper bound for an "age >= days" filter.
 * Matches BE semantics: `processDate <= processDateBefore`
 * (see `FetchCustodianActivitiesFilterForGrid.processDateBefore`).
 *
 * Unlike recon-flags `ageCutoffIso` (DateTime + end-of-day), processDate is a
 * date-only field, so `today - N` already covers the whole cutoff calendar day.
 */
export const processDateBeforeCutoff = (days: number): string =>
  dayjs.utc().subtract(days, 'day').format('YYYY-MM-DD');

/** Whole UTC calendar days between processDate and today (display aging). */
export const processDateAgingDays = (
  processDate: string | null | undefined,
): number => {
  if (!processDate) {
    return 0;
  }
  return Math.max(
    0,
    dayjs
      .utc()
      .startOf('day')
      .diff(dayjs.utc(processDate).startOf('day'), 'day'),
  );
};
